import React from 'react';
import PropTypes from 'prop-types';

export const IconProviderAvatarUx = ({ className, isDarkTheme }) => (
  <svg className={className} width="28" height="28" viewBox="0 0 312.05 310.38">
    <polygon fill={isDarkTheme ? '#fff' : '#13181d'} points="49.96 231.62 128.75 82.49 164.98 56.98 241.66 238.11 150.79 125.81 49.96 231.62" />
    <polygon fill="#7fd4f7" points="113.36 205.06 145.06 232.68 262.03 121.29 146.87 256.98 113.36 205.06" />
  </svg>
);

IconProviderAvatarUx.propTypes = {
  className: PropTypes.string,
  isDarkTheme: PropTypes.bool
};

IconProviderAvatarUx.defaultProps = {
  className: null,
  isDarkTheme: false
};
